import { render, staticRenderFns } from "./LoaderGlobal.vue?vue&type=template&id=5c3ce69b&scoped=true"
import script from "./LoaderGlobal.vue?vue&type=script&lang=js"
export * from "./LoaderGlobal.vue?vue&type=script&lang=js"
import style0 from "./LoaderGlobal.vue?vue&type=style&index=0&id=5c3ce69b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ce69b",
  null
  
)

export default component.exports